module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_souma-ab54698ae4ab88ecf3f25aeac62f4943.jpg";